/**
 * @author Madhuri <sai.madhuri@314ecorp.com>
 * @description React Hook usePostBatchEligibilityResubmission
 */
import api from 'client/index';
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import AppEvents from '@veritable/common/utils/appEvents';
import QUERY_KEYS from 'app-constants/queryKeys';

interface IProps {
	model: EligibilityRequests.IBatchResubmit;
}
/**
 * Mutate for post batch resubmission
 *
 */
const usePostBatchEligibilityResubmission = (): UseMutationResult<AnyType, IAxiosError, IProps, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ model }) => {
			const { data } = await api.EzapiApi.postBatchResubmitEligibilityRequest({
				batchEligibilityResubmitCreateModel: model,
			});
			return data;
		},
		onSuccess: () => {
			AppEvents.publishApiSuccess();
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.batchEligibilityRequest] });
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default usePostBatchEligibilityResubmission;
